import React, { useContext } from 'react';
import classnames from 'classnames';
import Flex from '@wix/da-ds/pkg/Flex';
import { useDeviationViewContext } from '../../../../Context';
import { SecondaryActionBarContext } from '../../../ActionBarContext';
import ActionBarStrip from '../../../_partials/ActionBarStrip';
import SubscribersOnly from '../../../_partials/SubscribersOnly';
import { useDeviationAttributes } from '../../../../DeviationViews/hooks/useDeviationAttributes';
import { isTextualDeviation } from '../../../../DeviationViews/_helpers';
import DeviationFlags from '../../../buttons/DeviationFlags';
import CommentButton from '../../../buttons/CommentButton';
import FavouriteButton from '../../../buttons/FavouriteButtonWithPopover';
import AddToGroupButton from '../../../buttons/AddToGroupButton/AddToGroupButtonWithPopover';
import MoreButton from '../../../buttons/MoreButton';
import EditButton from '../../../buttons/EditButton';
import EditBackgroundButton from '../../../buttons/EditBackgroundButton';
import DeleteButton from '../../../buttons/DeleteButton';
import ExpandButton from '../../../buttons/ExpandButton';
import FreeDownloadButton from '../../../buttons/DownloadButton/FreeDownloadButton';
import PremiumDownloadButton from '../../../buttons/DownloadButton/PremiumDownloadButton';
import AwardBadgeButton from '../../../buttons/AwardBadgeButton';
import DownloadWithCommentPrompt from '../../../buttons/DownloadButton/DownloadButtonWithCommentPrompt';
import SellYourArtLink from '../../../buttons/SellYourArtLink';
import FluidMargin from '../FluidMargin';
import AdoptSeller from '../../../buttons/AdoptableSeller';
import AdoptBuyer from '../../../buttons/AdoptableBuyer';
import AddToPrivateCollectionButton from '../../../buttons/AddToPrivateCollectionButtonWithPopover';
import { ElementVisibilityContext, ElementVisibility } from '../../../ElementVisibilityContext';
import desktopActionBarStyles from '../DesktopActionBar.scss';
export const PrimaryDesktopActionBar = ({ deviation, isOwner, className })=>{
    const elementVisibilityMap = useContext(ElementVisibilityContext);
    const { isTheater } = useDeviationViewContext();
    const { setTopActionBarRef } = useContext(SecondaryActionBarContext);
    const { hasFlag } = useDeviationAttributes(deviation, isOwner);
    const isTextual = isTextualDeviation(deviation);
    const badgeClassnames = classnames(desktopActionBarStyles['badge'], elementVisibilityMap.subscribe === ElementVisibility.Bar && desktopActionBarStyles['subs-badge']);
    const hasMoreActions = Object.values(elementVisibilityMap).includes(ElementVisibility.Menu);
    return /*#__PURE__*/ React.createElement(ActionBarStrip, {
        ref: setTopActionBarRef,
        className: classnames(desktopActionBarStyles['root'], isTheater ? desktopActionBarStyles['theater'] : desktopActionBarStyles['normal-view'], isOwner && desktopActionBarStyles['owner'], isTextual && desktopActionBarStyles['literature'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-wrapper']
    }, /*#__PURE__*/ React.createElement("div", {
        className: badgeClassnames
    }, hasFlag && /*#__PURE__*/ React.createElement(DeviationFlags, {
        className: desktopActionBarStyles['flag'],
        deviation: deviation,
        disableLabel: isTextual
    }), elementVisibilityMap.subscribe === ElementVisibility.Bar && /*#__PURE__*/ React.createElement(SubscribersOnly, {
        deviation: deviation,
        className: desktopActionBarStyles['subscribers-only'],
        textClassName: desktopActionBarStyles['subscribers-only-text']
    })), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 1
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-middle']
    }, /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, elementVisibilityMap.favourite === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'])
    }, /*#__PURE__*/ React.createElement(FavouriteButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), elementVisibilityMap.comment === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'], desktopActionBarStyles['icon-with-label'])
    }, /*#__PURE__*/ React.createElement(CommentButton, {
        deviation: deviation,
        isOwner: isOwner,
        actionBarType: "primary"
    }))), !isOwner && /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 4
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, elementVisibilityMap.privateCollection === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AddToPrivateCollectionButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), elementVisibilityMap.addToGroup === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AddToGroupButton, {
        deviation: deviation,
        actionBarType: "primary"
    })), elementVisibilityMap.awardBadge === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: classnames(desktopActionBarStyles['icon'])
    }, /*#__PURE__*/ React.createElement(AwardBadgeButton, {
        deviation: deviation
    })), elementVisibilityMap.premiumDownload === ElementVisibility.Bar && /*#__PURE__*/ React.createElement(DownloadWithCommentPrompt, {
        className: classnames(desktopActionBarStyles['icon']),
        buttonComponent: PremiumDownloadButton,
        deviation: deviation
    }), elementVisibilityMap.freeDownload === ElementVisibility.Bar && /*#__PURE__*/ React.createElement(DownloadWithCommentPrompt, {
        className: classnames(desktopActionBarStyles['icon']),
        buttonComponent: FreeDownloadButton,
        deviation: deviation
    }), elementVisibilityMap.elementGroups.adoptableSeller && /*#__PURE__*/ React.createElement(AdoptSeller, {
        className: desktopActionBarStyles['icon'],
        deviation: deviation
    }), elementVisibilityMap.elementGroups.adoptableBuyer && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(AdoptBuyer, {
        deviation: deviation
    }))), ([
        elementVisibilityMap.editDeviation,
        elementVisibilityMap.deleteDeviation
    ].includes(ElementVisibility.Bar) || hasMoreActions) && /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 2
    }), /*#__PURE__*/ React.createElement(Flex, {
        alignItems: "center"
    }, elementVisibilityMap.sellDeviation === ElementVisibility.Bar && /*#__PURE__*/ React.createElement(SellYourArtLink, {
        className: desktopActionBarStyles['icon'],
        deviation: deviation
    }), hasMoreActions && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(MoreButton, {
        deviation: deviation
    })), elementVisibilityMap.editBackground === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditBackgroundButton, {
        deviation: deviation
    })), elementVisibilityMap.deleteDeviation === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(DeleteButton, {
        deviation: deviation
    })), elementVisibilityMap.editDeviation === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(EditButton, {
        deviation: deviation
    })))), /*#__PURE__*/ React.createElement(FluidMargin, {
        index: 3
    }), /*#__PURE__*/ React.createElement("div", {
        className: desktopActionBarStyles['icons-right']
    }, elementVisibilityMap.fullscreen === ElementVisibility.Bar && /*#__PURE__*/ React.createElement("span", {
        className: desktopActionBarStyles['icon']
    }, /*#__PURE__*/ React.createElement(ExpandButton, {
        deviation: deviation
    })))));
};
PrimaryDesktopActionBar.displayName = 'PrimaryDesktopActionBar';
export default PrimaryDesktopActionBar;
